import api from '@/api';
import type { ApiResponse } from '@/types/api';
import { ApiFactory } from './base/ApiFactory';

/**
 * Service class for interacting with the Loyalty API endpoints.
 * Handles loyalty program membership operations.
 */
class DailyService extends ApiFactory<any> {
    /**
     * Creates an instance of DailyService.
     */
    constructor() {
        super('/daily-login', api);
    }

    /**
     * Links a membership to the user's account.
     * @param data - Membership link data
     * @returns Promise with link response
     */
    async claimDailyLogin(): Promise<ApiResponse<any>> {
        return this.post<ApiResponse<any>>(`${this.resource}/claim`);
    }
}
export const dailyService = new DailyService();
export default DailyService;
